import { render } from "./cipc_score.html?vue&type=template&id=d04cd540&external"
import script from "./cipc_score.js?vue&type=script&lang=js&external"
export * from "./cipc_score.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__